'use client';
import type { ProductFAQProps } from './data';

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Container,
  Text,
} from '@/components';

const ProductFAQ: ProductFAQProps = ({ faqs }) => {
  return (
    <Container>
      <Box borderColor="gray.400">
        <Accordion allowToggle>
          {faqs?.map((item) => (
            <AccordionItem
              key={item.id}
              borderTop="0"
              _notLast={{ borderBottom: '1px solid', borderColor: 'gray.400' }}
              _last={{ borderBottom: '0' }}
            >
              {({ isExpanded }) => (
                <>
                  <AccordionButton py={{ base: '3', md: '26px' }}>
                    <Text
                      flex="1"
                      textAlign="right"
                      fontSize={{ base: 'xs', md: 'lg' }}
                      color="text"
                    >
                      {item.question}
                    </Text>
                    <AccordionIcon
                      color={isExpanded ? 'secondary.500' : 'primary.500'}
                      width={{ base: '1.5rem', md: '2rem' }}
                      height={{ base: '1.5rem', md: '2rem' }}
                    />
                  </AccordionButton>
                  <AccordionPanel pb={4}>
                    <Text
                      fontSize={{ base: 'xs', md: 'lg' }}
                      color="text"
                      lineHeight="10"
                    >
                      {item.answer}
                    </Text>
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          ))}
        </Accordion>
      </Box>
    </Container>
  );
};
export default ProductFAQ;
